/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCorsAllowedOriginDto
 */
export interface CreateCorsAllowedOriginDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCorsAllowedOriginDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCorsAllowedOriginDto
     */
    description: string;
}

/**
 * Check if a given object implements the CreateCorsAllowedOriginDto interface.
 */
export function instanceOfCreateCorsAllowedOriginDto(value: object): value is CreateCorsAllowedOriginDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CreateCorsAllowedOriginDtoFromJSON(json: any): CreateCorsAllowedOriginDto {
    return CreateCorsAllowedOriginDtoFromJSONTyped(json, false);
}

export function CreateCorsAllowedOriginDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCorsAllowedOriginDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'description': json['description'],
    };
}

export function CreateCorsAllowedOriginDtoToJSON(json: any): CreateCorsAllowedOriginDto {
    return CreateCorsAllowedOriginDtoToJSONTyped(json, false);
}

export function CreateCorsAllowedOriginDtoToJSONTyped(value?: CreateCorsAllowedOriginDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'description': value['description'],
    };
}

